.audience-engagement-stats {
    width: 100%;
    height: 105px;
}
